import { BackgroundComponent } from "#core/components";
import { environment } from "#environments/environment";
import { inject, NgModule } from "@angular/core";
import { Routes, RouterModule, Router } from "@angular/router";
import { AuthTokenGuardService } from "#core/guards/auth-token-guard.service";

const routes: Routes = [
    {
        path: "",
        canActivate: [AuthTokenGuardService],
        runGuardsAndResolvers: "always",
        children: [
            {
                path: "teacher",
                runGuardsAndResolvers: "always",
                loadChildren: () =>
                    import("app/teacher/teacher.module").then(
                        (m) => m.TeacherModule
                    ),
            },
            {
                path: "student",
                runGuardsAndResolvers: "always",
                loadChildren: () =>
                    import("app/student/student.module").then(
                        (m) => m.StudentModule
                    ),
            },
            {
                path: "distributor",
                loadChildren: () =>
                    import("app/distributor/distributor.module").then(
                        (m) => m.DistributorModule
                    ),
            },
            {
                path: "lmsi",
                runGuardsAndResolvers: "always",
                loadChildren: () =>
                    import("app/lmsi/lmsi.module").then((m) => m.LmsiModule),
            },
            {
                path: "**",
                component: BackgroundComponent,//This component is chosen at random. It's meaningless. The guard will always redirect before it matters.
                canActivate: [() => inject(Router).createUrlTree(["/login"])],// We can't do a redirectTo directly on the path, because it takes priority over the guard, so it would never initialize the token.
            }
        ],
    },
    {
        path: "**",
        redirectTo: "login",
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            paramsInheritanceStrategy: "always",
            useHash: true,
            enableTracing: !environment.production,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
